export default `
.dte-sheet--compact {
  padding: 0.24in;
}

.dte-sheet--compact .dte-header-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 64px minmax(0, 1.42fr);
  gap: 6px;
  margin-bottom: 6px;
  align-items: start;
}

.dte-sheet--compact .dte-grid {
  gap: 6px;
}

.dte-sheet--compact .dte-spacer {
  height: 5px;
}

.dte-sheet--compact .dte-card__header {
  padding: 5px 7px;
  background:
    linear-gradient(180deg, var(--dte-card-header-gradient-strong) 0%, var(--dte-card-header-gradient-soft) 100%),
    var(--dte-brand);
  color: var(--dte-brand-contrast);
  font-size: calc(var(--dte-title-font-size) - 8px);
  letter-spacing: 0.05em;
}

.dte-sheet--compact .dte-card__body {
  padding: 7px 8px;
}

.dte-sheet--compact .dte-business-card {
  padding: 0;
}

.dte-sheet--compact .dte-business-card__media {
  min-width: 150px;
  max-width: 220px;
}

.dte-sheet--compact .dte-business-card__media--row {
  margin-bottom: 4px;
}

.dte-sheet--compact .dte-logo {
  max-width: 220px;
  max-height: 60px;
}

.dte-sheet--compact .dte-header-layout .dte-card {
  border: none;
  box-shadow: none;
  background: transparent;
  overflow: visible;
}

.dte-sheet--compact .dte-header-layout .dte-card__body {
  padding: 0;
}

.dte-sheet--compact .dte-header-layout .dte-card__header {
  padding: 0 0 4px;
  border-bottom: none;
  background: transparent;
}

.dte-sheet--compact .dte-header-layout__meta .dte-card__body {
  padding: 0;
  min-width: 0;
}

.dte-sheet--compact .dte-header-layout__meta .dte-card__header {
  font-size: calc(var(--dte-title-font-size) - 8px);
  line-height: 1.05;
}

.dte-sheet--compact .dte-header-layout__meta .dte-card__header--document-title {
  padding: 0 0 4px;
  font-size: calc(var(--dte-title-font-size) - 6px);
  letter-spacing: 0.02em;
  line-height: 1.08;
}

.dte-sheet--compact .dte-header-layout__meta .dte-definition-list {
  gap: 1px;
  min-width: 0;
}

.dte-sheet--compact .dte-header-layout__meta .dte-definition-list__row {
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 3px;
  font-size: calc(var(--dte-text-font-size) - 3px);
  line-height: 1.05;
}

.dte-sheet--compact .dte-header-layout__meta .dte-document-card {
  display: block;
  width: 100%;
  min-width: 0;
}

.dte-sheet--compact .dte-header-layout__meta .dte-document-card__info {
  width: 100%;
  min-width: 0;
}

.dte-sheet--compact .dte-header-layout__meta .dte-definition-list__row dd {
  min-width: 0;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.dte-sheet--compact .dte-header-layout__qr {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.dte-sheet--compact .dte-header-layout__qr-body {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2px !important;
}

.dte-sheet--compact .dte-card,
.dte-sheet--compact .dte-footer-contacts__card,
.dte-sheet--compact .dte-qrcode {
  border-radius: var(--dte-card-radius);
}

.dte-sheet--compact .dte-chip,
.dte-sheet--compact .dte-button {
  border-radius: 7px;
}

.dte-sheet--compact .dte-chip-row {
  gap: 5px;
  margin-bottom: 4px;
}

.dte-sheet--compact .dte-chip {
  min-height: 20px;
  padding: 0 6px;
  font-size: calc(var(--dte-text-font-size) - 2px);
}

.dte-sheet--compact .dte-definition-list__row {
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 5px;
  font-size: calc(var(--dte-text-font-size) - 1px);
  line-height: 1.08;
}

.dte-sheet--compact .dte-table th,
.dte-sheet--compact .dte-table td {
  padding: 4px 5px;
  font-size: calc(var(--dte-text-font-size) - 2px);
}

.dte-sheet--compact .dte-table thead th {
  font-size: calc(var(--dte-title-font-size) - 8px);
}

.dte-sheet--compact .dte-table--detail th,
.dte-sheet--compact .dte-table--detail td {
  padding: 3px 4px;
  font-size: calc(var(--dte-detail-font-size) - 1px);
  line-height: 1.04;
}

.dte-sheet--compact .dte-table--detail thead th {
  font-size: calc(var(--dte-detail-font-size) - 2px);
}

.dte-sheet--compact .dte-summary {
  grid-template-columns: 1fr;
  align-items: start;
}

.dte-sheet--compact .dte-summary--single {
  grid-template-columns: 1fr;
}

.dte-sheet--compact .dte-footer-card {
  grid-column: 1 / -1;
  width: 100%;
}

.dte-sheet--compact .dte-total-row {
  gap: 7px;
  font-size: calc(var(--dte-text-font-size) - 1px);
  line-height: 1.08;
  padding-bottom: 4px;
}

.dte-sheet--compact .dte-total-row.is-emphasis {
  font-size: calc(var(--dte-title-font-size) - 5px);
}

.dte-sheet--compact .dte-qrcode {
  width: 70px;
  height: 70px;
  padding: 3px;
}

.dte-sheet--compact .dte-qrcode--compact-header {
  width: 60px;
  height: 60px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 0;
}

.dte-sheet--compact .dte-qrcode--compact-placeholder {
  border: 1px dashed rgba(47, 93, 140, 0.35);
  background: rgba(47, 93, 140, 0.04);
}

.dte-sheet--compact .dte-qrcode--plain {
  padding: 0;
}

.dte-sheet--compact .dte-qr-card {
  gap: 6px;
}

.dte-sheet--compact .dte-qr-card__text,
.dte-sheet--compact .dte-footer-note {
  font-size: calc(var(--dte-text-font-size) - 2px);
  line-height: 1.12;
}

.dte-sheet--compact .dte-section-title {
  margin: 0 0 6px;
  font-size: calc(var(--dte-text-font-size) - 1px);
}

.dte-sheet--compact .dte-footer-contacts {
  gap: 6px;
}

.dte-sheet--compact .dte-footer-contacts__card {
  padding: 7px;
}
`;
